/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_PlaybackInputs */

const en_settings_v2_playback = /** @type {(inputs: Settings_V2_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playback`)
};

const es_settings_v2_playback = /** @type {(inputs: Settings_V2_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducción`)
};

/**
* | output |
* | --- |
* | "Playback" |
*
* @param {Settings_V2_PlaybackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_playback = /** @type {((inputs?: Settings_V2_PlaybackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_PlaybackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_playback(inputs)
	return en_settings_v2_playback(inputs)
});